import { LanguageCode } from '../../localization/LanguageCode';

class HubSpotLocaleResolver {
  private static readonly defaultLocale = 'en';

  /** Keys are normalized language codes; values are HubSpot's own locale identifiers. */
  private static readonly locales = new Map([
    ['da-dk', 'da'],
    ['de-at', 'de'],
    ['de-ch', 'de'],
    ['de-de', 'de'],
    ['en-gb', 'en-gb'],
    ['en-us', 'en'],
    ['fr-be', 'fr'],
    ['fr-ch', 'fr'],
    ['fr-fr', 'fr'],
    ['nb-no', 'no-no'],
    ['nl-be', 'nl'],
    ['nl-nl', 'nl'],
    ['pl-pl', 'pl'],
    ['sv-se', 'sv'],
  ]);

  public static resolve(languageCode: string) {
    return this.locales.get(LanguageCode.normalize(languageCode)) ?? this.defaultLocale;
  }
}

export default HubSpotLocaleResolver;
